import { z } from 'zod';
import { useTextes } from '@common/config';

const PHONE_REGEX = /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/;

const t = useTextes('Commun', 'Formulaire');

export const Z_PHONE = z
  .string()
  .nonempty({ message: t['ADM_MES6'] })
  .regex(PHONE_REGEX, { error: t['ADM_MES1'] });

export const PHONE_PLACEHOLDER = '06********';